import { Card } from "antd";
import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const SalesByDevice = () => {
  // Data for the donut chart
  const deviceData = [
    {
      device: "Website App",
      sales: 850,
      color: "#F59E0B", // Orange/Yellow
    },
    {
      device: "Mobile App",
      sales: 724,
      color: "#EF4444", // Red/Coral
    },
    {
      device: "Admin",
      sales: 750,
      color: "#10B981", // Green
    },
  ];

  // Calculate total sales
  const totalSales = deviceData.reduce((sum, item) => sum + item.sales, 0);

  // Custom tooltip
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0];
      const percentage = ((data.value / totalSales) * 100).toFixed(1);
      return (
        <div className="bg-black p-2 border rounded shadow-lg">
          <p className="font-medium text-white">{data.payload.device}</p>
          <p className="text-sm text-white">
            {`Sales: ${data.value.toLocaleString()}`}
          </p>
          <p className="text-sm text-white">{`${percentage}%`}</p>
        </div>
      );
    }
    return null;
  };

  // Custom label for center total
  // const renderCustomLabel = () => {
  //   return (
  //     <text
  //       x="50%"
  //       y="50%"
  //       textAnchor="middle"
  //       dominantBaseline="middle"
  //       className="fill-gray-800"
  //     >
  //       <tspan
  //         x="50%"
  //         dy="-0.5em"
  //         className="text-sm font-normal fill-gray-500"
  //       >
  //         Total
  //       </tspan>
  //       <tspan
  //         x="50%"
  //         dy="1.2em"
  //         className="text-2xl font-semibold fill-gray-800"
  //       >
  //         {totalSales.toLocaleString()}
  //       </tspan>
  //     </text>
  //   );
  // };

  return (
    <Card
      title="Sales By Devices"
      className="shadow-sm border border-gray-100"
      styles={{ body: { padding: "24px" } }}
    >
      <div className="h-56 relative">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={deviceData}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={100}
              paddingAngle={8}
              dataKey="sales"
            >
              {deviceData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>

        {/* Center total text */}
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <span className="text-sm text-gray-500">Total</span>
          <span className="text-2xl font-semibold text-gray-800">
            {totalSales.toLocaleString()}
          </span>
        </div>
      </div>

      {/* Legend */}
      <div className="pt-4 border-t border-gray-100 mt-4">
        <div className="flex items-center justify-center space-x-6">
          {deviceData.map((item, index) => (
            <div key={index} className="flex items-center space-x-2">
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: item.color }}
              ></div>
              <span className="text-sm text-gray-600">{item.device}</span>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default SalesByDevice;
